import { Component, Input, OnInit, SimpleChange } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { StorageService } from 'src/app/Services/storage.service';
const route_Icon = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="18px" viewBox="0 0 20 20" width="18px" fill="#FFFFFF"><g><rect fill="none" height="20" width="20" x="0"/></g><g><g><path d="M15.25,12.13V6c0-1.65-1.35-3-3-3s-3,1.35-3,3v8c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5V7.87C7.26,7.55,8,6.62,8,5.5 C8,4.12,6.88,3,5.5,3C5.33,3,5.16,3.02,5,3.05C4.67,3.12,4.37,3.25,4.1,3.43C3.44,3.88,3,4.64,3,5.5c0,0.86,0.44,1.62,1.1,2.07 C4.37,7.75,4.67,7.88,5,7.95C4.91,7.93,4.83,7.9,4.75,7.87V14c0,1.65,1.35,3,3,3s3-1.35,3-3V6c0-0.83,0.67-1.5,1.5-1.5 s1.5,0.67,1.5,1.5v6.13c0.08-0.03,0.16-0.06,0.25-0.08c-0.33,0.07-0.63,0.2-0.89,0.38c-0.67,0.45-1.1,1.21-1.1,2.07 c0,0.86,0.44,1.62,1.1,2.07c0.27,0.18,0.57,0.31,0.89,0.38c0.16,0.03,0.33,0.05,0.5,0.05c1.38,0,2.5-1.12,2.5-2.5 C17,13.38,16.26,12.45,15.25,12.13z M4.5,5.5c0-0.55,0.45-1,1-1s1,0.45,1,1s-0.45,1-1,1S4.5,6.05,4.5,5.5z M14.5,15.5 c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S15.05,15.5,14.5,15.5z"/></g></g></svg>`;
declare var google: any;
declare const mapUtilityMapBox;

@Component({
  selector: 'g10-dashboard-route-information',
  templateUrl: './route-information.component.html',
  styleUrls: ['./route-information.component.css']
})
export class RouteInformationComponent implements OnInit {

  public initialGetData:boolean = true;
  @Input() public set routeInfo(val: any) {
    this.selectedRouteData = val;
    if (Object.keys(val).length > 0 && this.initialGetData) {
      this.getStEndLocationData();
      this.initialGetData = false;
    }
  }
  @Input() selectedTapRouteExploar:any;
  public pickupPoints = [];
  public noDataEnable: boolean = false;

  public allVehicleSelected: boolean = false;

  public selectedVehicle: any = {};
  public selectedrouteVehilePPInfo: any = {};
  public vehicleTableData = [];
  public routeStEndLocData = {};
  public activeIndex;
  public activeSelection = {};
  public selectedRouteData: any;
  public employeeListData = [];
  public employeeListTitle = '';
  public routeInformationMapBox: any;
  public objKeys = Object.keys;
  public map_marker_vehRegNo_style = 'hidden';
 //for map
  public selectedMap:string='openStreetMap';
  // public selectedMap:string='google';
  public googleMapObj:any;
  public globalMarkers:any=[];
  public routeLine:any;
  public gglPickupPointMarker:any=[];

  constructor(
    public mapService: MapService,
    public api: ApiService,
    private swal: SweetAlert,
    private routeservice: RouteService,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
    private route: Router,
    private storage: StorageService
  ) {
    iconRegistry.addSvgIconLiteral('routeIcon', sanitizer.bypassSecurityTrustHtml(route_Icon));
  }


  ngOnInit(): void {
    let user= this.storage.get('userInfo');
    if(user && user.map){
      this.selectedMap = user.map;
    }
    
    let chekRouteExplore = this.storage.get('routeExploration');
    if (chekRouteExplore != undefined && chekRouteExplore != null && chekRouteExplore != '') {
      if (chekRouteExplore['selecteVehicle'] != undefined && chekRouteExplore['selecteVehicle'] != null && chekRouteExplore['selecteVehicle'] != '') 
        this.selectedVehicleData(chekRouteExplore['selecteVehicle']);
    setTimeout(() => {
      this.storage.setData({ 'routeExploration': '' });
    }, 500)
    }
    this.loadMap();
    this.getCompletedPPList();
  }
  
  // ngOnChanges(changes:SimpleChange){
  //   if (changes['routeInfo']){
  //     this.routeInfo = { ...changes['routeInfo'].currentValue};
  //     console.log(this.routeInfo);
  //     this.getStEndLocationData();
  //   }
  // }

  getCompletedPPList(){
        console.log('Selected ', this.selectedRouteData);
  }
  selectedVehicleData(veh: any) {
    this.selectedVehicle = veh;
    // console.log(veh);
    // let temp = {
    //   "61a895a1d18eef76dd1eb567": {ata:"12:14"},
    //   "61a91286d18eef76dd1eb5a3": {ata:"12:14"},
    //   "61a912b1d18eef76dd1eb5a4": {ata:"12:14"},
    //   "61a912e8d18eef76dd1eb5a5": {ata:"12:14"},
    //   "61a91328d18eef76dd1eb5a6": {ata:"12:14"},
    //   "61a9136ad18eef76dd1eb5a7": {ata:"12:14"},
    //   "61a913ccd18eef76dd1eb5a8": {ata:"12:14"},
    //   "61a91404d18eef76dd1eb5a9": {ata:"12:14"},
    //   "61a9143fd18eef76dd1eb5aa": {ata:"12:14"},
    // }
    this.selectedrouteVehilePPInfo = {
      routeName: this.selectedRouteData['title'],
      vehicleName: this.selectedVehicle['vehRegNo'],
      pickupPoints: this.selectedVehicle['pickupPoints'],
      memberCnt: (this.selectedVehicle['pickupPoints'].map(pp => { 
        pp['memberCnt']=this.getMemberCount(pp); 
        return this.getMemberCount(pp) })).reduce((a, b) => a + b, 0),
      currentPP: 0,

    }
    // console.log(this.selectedrouteVehilePPInfo);
    this.api.getCompletedPPList({
      routeID: this.selectedRouteData['routeID'],
      vehRegNo: this.selectedVehicle['vehRegNo']
    }).then((res:any)=>{
      if(res.status=='success'){
        let temp = res.data;
        this.selectedrouteVehilePPInfo['pickupPoints'].map((pp:any)=>{
          // console.log('PP --> ', pp)
               if(temp[pp['pickuppointID']]){
                 pp['completed']= true;
                 pp['ata']= temp[pp['pickuppointID']]['ata'];
               }else  pp['completed']= false;
               return pp;
         });
      }
    })
    
    // console.log('pickupInfo',this.selectedrouteVehilePPInfo);

  }

  getMemberCount(pp){
    let result = 0;
    if(pp['assignedGuest']) result = result + pp['assignedGuest'].length;
    if(pp['assignedEmployees']) result = result + pp['assignedEmployees'].length;

    return result
  }

  getStEndLocationData(){
    this.routeStEndLocData = {};
    this.api.transportManagerRouteStEndLocList({ routeID: this.selectedRouteData.routeID, vehRegNo: this.selectedRouteData.vehicle}).then((res: any) => {
        if (res.status == 'success') {           
            this.routeStEndLocData = { ...res.data};
          }
          this.getPickupList(this.selectedRouteData);
    }).catch((err) => {
        console.log(err); 
    });
}

  getPickupList(routeData) {

    let apiMethod = 'listRoutePickupPoint';
    if(routeData && routeData.routeType && routeData.routeType=='openBooking'){
      apiMethod = 'transportManagerOpenBookingRouteListPP';
    }

    this.api[apiMethod]({ routeID: routeData.routeID }).then((res: any) => {
      if (res.status == 'success' || res.status == 'Success') {   
        this.pickupPoints = res && res.data;        
      }
      else if(res.status == 'failure'){
        this.pickupPoints = [];
        this.noDataEnable = true;
      }
      this.setVehicleTable();
    });
  }

  setVehicleTable() {
    let uniqueVehicles = [];
    this.vehicleTableData = [];
    // this.pickupPoints.filter((pp) => { if (uniqueVehicles.indexOf(pp.vehRegNo) == -1) uniqueVehicles.push(pp.vehRegNo); });
    uniqueVehicles = this.selectedRouteData['vehicle'];
    if(uniqueVehicles.length>0){
      uniqueVehicles.filter((vehRegNo) => {
        let obj = {
          vehRegNo: vehRegNo,
          checked: false,
          totalEmp: 0,
          pickupPoints: [],
        };
        if(this.getEndLocationData(vehRegNo)!='') obj['endLoc'] = this.getEndLocationData(vehRegNo);
        if(this.getStartLocationData(vehRegNo,'lat') != '') obj['lat'] = this.getStartLocationData(vehRegNo,'lat');
        if(this.getStartLocationData(vehRegNo,'lng') != '') obj['lng'] = this.getStartLocationData(vehRegNo,'lng');
        if(this.getStartLocationData(vehRegNo,'name') != '') obj['locationName'] = this.getStartLocationData(vehRegNo,'name');
        if (this.pickupPoints.length > 0) {
          this.pickupPoints.filter((pp) => {
            if (pp.vehRegNo == vehRegNo) {
              if(pp.employees) obj['totalEmp'] += pp.employees.length;
              if(pp.guest) obj['totalEmp'] += pp.guest.length;
              obj['pickupPoints'].push(pp);
            }
          });
        }
        this.vehicleTableData.push(obj);
      });
    }
    setTimeout(()=>{ this.noDataEnable = true;},300);
  }

  checkDisableVeh(vehRegNo){
    let result = false;
    if(this.objKeys(this.routeStEndLocData).length<=0 
        || this.routeStEndLocData[vehRegNo] == undefined 
        || this.routeStEndLocData[vehRegNo]['startLoc']==undefined 
        || this.objKeys(this.routeStEndLocData[vehRegNo]['startLoc']).length<=0)
        {
          result = true;
        }
    return result;
  }
  checkPopupMessage(vehRegNo){
    let msg = 'Configure start location and end location';
    if(this.objKeys(this.routeStEndLocData).length<=0 && this.routeStEndLocData[vehRegNo] != undefined){
      let stLocUndefined = this.routeStEndLocData[vehRegNo]['startLoc']==undefined ;
      let endLocUndefined = this.routeStEndLocData[vehRegNo]['endLoc']==undefined;
      let stLocNoData = this.objKeys(this.routeStEndLocData[vehRegNo]['startLoc']).length<=0;
      let endLocNoData = this.objKeys(this.routeStEndLocData[vehRegNo]['endLoc']).length<=0;
      if((stLocUndefined || stLocNoData) && (endLocUndefined || endLocNoData))
        msg = "Configure start location and end location";
      else if(stLocUndefined || stLocNoData)
        msg = "Configure start location";
      else if(endLocUndefined || endLocNoData)
        msg = "Configure end location";
    }
    return msg;
  }

  checkAllDisableVeh(){
    let result = false;
    if(this.vehicleTableData.length>0){
      this.vehicleTableData.filter((veh)=>{ 
        if(this.checkDisableVeh(veh.vehRegNo)) result = true;
      })
    }else result = true;
    return result;
  }

  getStartLocationData(vehRegNo,returnType){
    let result = '';
    if(this.routeStEndLocData[vehRegNo] && this.routeStEndLocData[vehRegNo]['startLoc'] && this.routeStEndLocData[vehRegNo]['startLoc'][returnType]){
      result = this.routeStEndLocData[vehRegNo]['startLoc'][returnType];
    }
    return result;
  }
  getEndLocationData(vehRegNo){
    let result:any;
    if(this.routeStEndLocData[vehRegNo] && this.routeStEndLocData[vehRegNo]['endLoc']){
      result = this.routeStEndLocData[vehRegNo]['endLoc'];
    }
    return result;
  }

  loadMap() {
    this.initMap();   
   /*  this.mapService.map("routeInformationMapBox").then((map) => {
      this.routeInformationMapBox = map;
    }).catch((error) => {
      console.log('routeInformationMapBox', error);
    }); */
  }

  initMap(){
    if(this.selectedMap == 'google'){
      setTimeout(()=>{
        const mapOptions = {
          scrollwheel: true,
          zoom: 5,
          maxZoom: 17,
          center: new google.maps.LatLng(20.5937, 78.9629),
          disableDefaultUI: false
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('routeInformationMapBox'), mapOptions);
        if(this.pickupPoints.length>0){
          this.setGoogleMarker();
        }
      },1000)
    }else{
      try {
          const mapBoxKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
          const parent = this;
          if (mapBoxKey) {
            const MyMap1 = new mapUtilityMapBox();
            MyMap1.setup('routeInformationMapBox', {
              key: mapBoxKey
            },
              function (map) {             
                parent.routeInformationMapBox = map;  
                parent.routeInformationMapBox.removeMarkerAll();
                parent.routeInformationMapBox.removeLineAll();
                parent.routeInformationMapBox.onMapZoom((z) =>{
                    /* show vehicle Reg No when zoom level is above 13 */
    
                    if (z >= 13) {
                      if (parent.map_marker_vehRegNo_style == 'hidden') {
                          const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                        for (let i = 0; i < veh_Reg_nums.length; i++) {
                          const elem: any = veh_Reg_nums[i];
                          elem.style.visibility = 'visible';
                        }
                        parent.map_marker_vehRegNo_style = 'visible';
                      }
                    }
                    else {
                      if (parent.map_marker_vehRegNo_style == 'visible') {
                          const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                        for (let i = 0; i < veh_Reg_nums.length; i++) {
                          const elem: any = veh_Reg_nums[i];
                          elem.style.visibility = 'hidden';
                        }
                        parent.map_marker_vehRegNo_style = 'hidden';
                      }
                    }                  
                });
  
                if(parent.vehicleTableData.length > 0) parent.addVehicleMarker();
              });
          }
        } catch (error) {
          console.log(error);
        }
    }
  }
  setGoogleMarker(){
    let infoWindowContent;
    let infowindow;
    let filVal;
    for(let i=0;i<this.vehicleTableData.length;i++){
      let loc={
        lat :+this.vehicleTableData[i]['lat'],
        lng :+this.vehicleTableData[i]['lng'],
      }
      let image ={
        url:"assets/images/map/googleMap/bus_main.png"
      };
      let marker= new google.maps.Marker({
        position : loc,
        map:this.googleMapObj,
        icon:image,
      })
      marker.addListener('click',(e)=>{
        filVal=this.vehicleTableData.filter(obj=> e.latLng.lat() == obj.lat && e.latLng.lng() == obj.lng);
        if(infowindow) infowindow.close();
        if(filVal.length>0){
            infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + filVal[0].vehRegNo + '</span><div style="margin-top:2px">'+'Location :'+'<span>'+' '+filVal[0].locationName+'</span></div><div style="margin-top:2px">'+'Pickup Points :'+'<span>'+' '+filVal[0].pickupPoints.length+'</span></div></div>';
            infowindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });
        }
        this.googleMapObj.setZoom(15);
        this.googleMapObj.panTo(loc);
      })
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(this.googleMapObj, this);
      });
      this.globalMarkers.push(marker);
      this.googleMapObj.setZoom(10);
      this.googleMapObj.panTo(loc);
    }
  }
  toDateFormat(value) {
    if (!value) return '';
    let date:any=new Date(value);
    date=date.toDateString();
    return date;
  }
  allSelectVehicleToggle(value) {
    this.vehicleTableData.filter((e, index) => {
      e.checked = value;
    });
    if (value) this.drawAllLine();
    else this.drawSelectedLine();
  }

  checkAllVehicleChecked() {
    let result = true;
    this.vehicleTableData.filter((e) => { if (!e.checked) result = false; })
    return result;
  }

  checkAllVehicleIndeterminate(): boolean {
    if (this.vehicleTableData.length == 0) {
      return false;
    }
    return this.vehicleTableData.filter(t => t.checked).length > 0 && !this.checkAllVehicleChecked();
  }

  singleVehicleToggle(value, index) {
    this.vehicleTableData[index]['checked'] = value;
    if (this.vehicleTableData[index]['checked']){     
      this.selectedVehicle = { ...this.vehicleTableData[index]};
    }else {
      if(this.selectedMap=='google'){
        if(this.gglPickupPointMarker.length>0){
          for(let i=0;i<this.gglPickupPointMarker.length;i++){
              this.gglPickupPointMarker[i].setMap(null);
          }
      }
      if(this.routeLine){
          this.routeLine.setMap(null);
      }
      }else{
        this.selectedVehicle = {};
      }
    }
    if (this.checkAllVehicleChecked()) this.drawAllLine();
    else this.drawSelectedLine();
  }
  drawAllRoutesGgl(){
    if(this.gglPickupPointMarker.length>0){
      for(let i=0;i<this.gglPickupPointMarker.length;i++){
        this.gglPickupPointMarker[i].setMap(null);
      }
    }
    if(this.routeLine){
        this.routeLine.setMap(null);
    }
  }
  async drawSelectedRouteGgl(){
    let vehRegNos=Object.keys(this.routeStEndLocData);
    if(this.gglPickupPointMarker.length>0){
        for(let i=0;i<this.gglPickupPointMarker.length;i++){
            this.gglPickupPointMarker[i].setMap(null);
        }
    }
    if(this.routeLine){
        this.routeLine.setMap(null);
    }
    let locs=[];
    let sortedPickupPoints = this.pickupPoints.sort(
      (p1, p2) => (p1.etaDecimal > p2.etaDecimal) ? 1 : (p1.etaDecimal < p2.etaDecimal) ? -1 : 0);
    for(let i=0;i<vehRegNos.length;i++){
      let start=[this.routeStEndLocData[vehRegNos[i]]['startLoc']['lat'],this.routeStEndLocData[vehRegNos[i]]['startLoc']['lng']];
      locs.push(start);
      for(let j=0;j<sortedPickupPoints.length;j++){
        let pPoint=[sortedPickupPoints[j]['lat'],sortedPickupPoints[j]['lng'],{'title' :sortedPickupPoints[j]['location']}];
        locs.push(pPoint);
      }
      let end=[this.routeStEndLocData[vehRegNos[i]]['endLoc']['lat'],this.routeStEndLocData[vehRegNos[i]]['endLoc']['lng']];
      locs.push(end);
    }
    let wayPointsLocations:any;
    wayPointsLocations = await this.routeservice.findWayPoints(locs);
    let position={};
    let location=[];
    for(let i=0;i<wayPointsLocations.length;i++){
        if(Object.keys(wayPointsLocations[i]).length==3){
            position={
                lat : +wayPointsLocations[i][0],
                lng : +wayPointsLocations[i][1],
                pickupPoint : wayPointsLocations[i][2]['title']
            }
        }else{
            position={
                lat : +wayPointsLocations[i][0],
                lng : +wayPointsLocations[i][1]
            }
        }
        if(i==0){
            position['loc']='start';
        }else if(i==wayPointsLocations.length-1){
            position['loc']='end';
        }
        location.push(position);
    }
    var image = {
      origin: new google.maps.Point(0, 0),
    };
    let infoWindowContent;
    let infowindow;
    let filVal;
    for (let i = 0; i < location.length; i++) {
          if(location[i].loc=='start'){
            image['url']= "assets/images/map/googleMap/start.png";
            image['scaledSize']=new google.maps.Size(30,36);
          }else if(location[i].loc=='end'){
            image['url']= "assets/images/map/googleMap/finish.png";
            image['scaledSize']=new google.maps.Size(30,36);
          }else if(location[i]['pickupPoint']){
            image['url']= "assets/images/map/googleMap/pickuppoint-purple.png";
            image['scaledSize']=new google.maps.Size(24,36);
          }
          if(i==0 || i==location.length-1 || location[i]['pickupPoint']){
            this.gglPickupPointMarker.push(new google.maps.Marker({
            position:location[i],
            map: this.googleMapObj,
            icon: image
          }));
          for(let j=0;j<this.gglPickupPointMarker.length;j++){
            this.gglPickupPointMarker[j].addListener('click',(e)=>{
              if(location[i]['pickupPoint']){
                filVal=this.pickupPoints.filter(obj=> e.latLng.lat() == obj.lat && e.latLng.lng() == obj.lng);
                if(infowindow) infowindow.close();
                if(filVal.length>0){
                    infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + filVal[0].title + '</span><div style="margin-top:2px">'+'Location :'+'<span>'+' '+filVal[0].location+'</span></div><div style="margin-top:2px">'+'Vehicle :'+'<span>'+' '+filVal[0].vehRegNo+'</span></div><div style="margin-top:2px">'+'ETA :'+'<span>'+' '+filVal[0].eta+'</span></div><div style="margin-top:2px">'+'Updated :'+' '+'<span>'+this.toDateFormat(filVal[0].updatedAt)+'</span>'+'</div>'+'</div>';
                    infowindow = new google.maps.InfoWindow({
                        content: infoWindowContent
                    });
                }
              }
              this.googleMapObj.setZoom(15);
              this.googleMapObj.panTo(this.gglPickupPointMarker[j].position);
            })
            if(location[i]['pickupPoint']){
              google.maps.event.addListener(this.gglPickupPointMarker[j], 'click', function() {
                  infowindow.open(this.googleMapObj, this);
              });
            }
          }
          }
        }
        this.routeLine = new google.maps.Polyline({
          path: location,
          geodesic: true,
          strokeColor: this.getRandomColor(),
          strokeOpacity: 1.0,
          strokeWeight: 2,
        })
        this.routeLine.setMap(this.googleMapObj);
    var bounds = new google.maps.LatLngBounds();
    for (let i = 0; i < location.length; i++) {
        bounds.extend(location[i]);
    }
    bounds.getCenter();
    this.googleMapObj.fitBounds(bounds);
  }

  getPPList(pp: any) {
    // console.log('this.selectedVehicle ', pp)

    // this.api.listRoutePickupPoint({vehRegNo: this.selectedVehicle}).then((res:any)=>{
    //   console.log('RESPONCE ---> ', res)
    // })


  }

  expandMore(index) {
    this.activeIndex = index;
  }
  expandLess() {
    this.activeIndex = undefined;
  }

  getPPEmployees(pickuppointID){
    this.employeeListData = [];
    this.employeeListTitle = '';
    this.selectedrouteVehilePPInfo['pickupPoints'].filter((pp)=>{ 
      if(pp.pickuppointID == pickuppointID) {
        this.employeeListTitle = pp.title;
        this.employeeListData = [ ...pp.employees];
      }
    })
  }
  getAllEmployees(){

  }
  closeEmployeeInfo(){
    this.employeeListData = [];
    this.employeeListTitle = '';
  }

  managePickupPoint() {
    // console.log('Manage Pp ',this.selectedRouteData['routeType'],this.selectedRouteData['routeID'],this.selectedRouteData);
    // console.log()
    // this.store.
    let data:any={
      isVehicleDataHide: true,
      selectedRoute: this.selectedRouteData,
      selectedTapRouteExploar:this.selectedTapRouteExploar,
      selecteVehicle: this.selectedVehicle
    }
    this.storage.setData({'routeExploration': data});
    setTimeout(()=>{
      this.route.navigate(['organization/transport-manager/rostering/edit-route/' + this.selectedRouteData['routeType'] + '/' + this.selectedRouteData['routeID'] + '/' + this.selectedVehicle['vehRegNo']])
    },300)

  }
  showTrip(vehicle) {
    let pickupLocations = vehicle.pickupPoints.map((pp) => {
      let item = pp;
      return [item.lat, item.lng, { title: item.title }];
    });
    pickupLocations = pickupLocations.reverse();
    let vehicleLoc = [vehicle.lat, vehicle.lng, { title: vehicle.vehRegNo.toUpperCase() }];
    if (vehicle.endLoc != undefined && vehicle.endLoc != null) pickupLocations.unshift([vehicle.endLoc.lat, vehicle.endLoc.lng, { title: 'End Location' }]);
    pickupLocations.push(vehicleLoc);

    this.drawLine(pickupLocations, vehicle.vehRegNo);
  }

  async drawLine(locations = [], vehRegNo) {
    let wayPointsLocations: any = await this.routeservice.findWayPoints(locations);
    setTimeout(() => {
      this.routeInformationMapBox.addLine({
        id: 'g10_routeInformation_line_' + vehRegNo,
        locations: wayPointsLocations.reverse(),
        color: this.getRandomColor(),
        width: 3,
        // dash : 2,
        animation: false,
        //lineBearing: 1 * 1000,
        //startMarker: '<div class="mumb_marker_pin" style="background: green;"></div><div class="mumb_marker_pulse" style="background: green;"></div>',
        //  bearingMarker : '<div class="mumb_marker_pulse" style="background: red;"></div>', //'<img src="map-assets/images/ripple-circle.gif">' 
        bearingFocus: true,
        //plotMarker: '<div class="mumb_marker_pulse" style="background: black; width: 10px;"></div>',
        //endMarker: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div>',
        drawArrow: {
          colorClass: 'secondary'
        }
      });
      this.addPickupPointMarker(locations, vehRegNo);
    }, 500)
  }

  getRandomColor() {
    let color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  addVehicleMarker() {
    let vehicleMarkers = [];
    let vehicleLocations = [];
    this.vehicleTableData.filter((vehicle) => {
      let item = vehicle;
      if(item.lat && item.lng){
        vehicleMarkers.push('g10_routeInformation' + item.vehRegNo);
        vehicleLocations.push([item.lat, item.lng, { title: item.vehRegNo }]);
      }
    });
    let markers = [];
    vehicleLocations.filter((loc) => {
      let marker = {
        id: 'g10_routeInformation' + loc[2]['title'],
        content: '<img src="../../../../../../assets/images/dashboard/vehicle-marker.png" style="height: 40px;width: 28px;position: relative;top: 4px;left: -6px;"><div class="mumb_marker_pulse" style="background: transparent;"></div>',
        lat: loc[0],
        lng: loc[1],
      };
      markers.push(marker);
    });

    setTimeout(() => {
      this.routeInformationMapBox.removeMarker([vehicleMarkers]);
      if(vehicleLocations.length>0){
        this.routeInformationMapBox.addMarkers(markers);
        let focusObj = { lat: vehicleLocations[0][0], lng: vehicleLocations[0][1], zoom: 14, }
        this.routeInformationMapBox.focus(focusObj);
      }
    }, 100);

  }

  addPickupPointMarker(locations, vehRegNo) {
    if (locations.length > 1) locations.reverse();
    if (locations.length > 0) {
      let markers = [];
      locations.filter((loc, i) => {
        if (i == locations.length - 1 && i != 0) {
          let eMarker = {
            id: `g10_routeInformation_${vehRegNo}_ppEndMarker`,
            content: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div>',
            lat: loc[0],
            lng: loc[1],
          };
          markers.push(eMarker);
        } else if (i != locations.length - 1 && i != 0) {
          let plotMarker = {
            id: `g10_routeInformation_${vehRegNo}_ppMiddleMarker_${i}`,
            content: `<div class="mumb_marker_pulse" style="background: #6264a7; width: 10px;"></div>
            <span class="map_marker_vehRegNo rosteringPPtitle" id="route_rostering_pickupPoint_ppMiddleMarker_${i}" *ngIf="${this.markerTitleTitlecase(loc[2]['title'])!=''}">${(i)+'. '+this.markerTitleTitlecase(loc[2]['title'])}</span>`,
            lat: loc[0],
            lng: loc[1],
          }
          markers.push(plotMarker);
        }
      })
      let markerIDs = markers.map((marker) => { return marker.id; });
      this.routeInformationMapBox.removeMarker(markerIDs);
      this.routeInformationMapBox.addMarkers(markers);

      setTimeout(() => {

        let focusObj = { lat: locations[0][0], lng: locations[0][1], zoom: 14, }
        if (locations.length > 1) {
          let index = locations.length - 1;
          focusObj = { lat: locations[index][0], lng: locations[index][1], zoom: 14, }
        }
        this.routeInformationMapBox.focus(focusObj);
      }, 500);
    }
  }

  markerTitleTitlecase(title){
    if(title!=''){
        let result = title.toLowerCase().split(' ').map((w)=>{ return (w.charAt(0).toUpperCase() + w.slice(1)) });
        return result.join(' ');
    }
    else return ''
  }

  drawAllLine() {
    if(this.selectedMap=='google'){
      if(this.globalMarkers.length>0){
        for(let i=0;i<this.globalMarkers.length;i++){
          this.globalMarkers[i].setMap(null);
        }
      }
      this.drawSelectedRouteGgl();
    }else{
      this.vehicleTableData.filter((vehicle) => {
  
        let markers = [`g10_routeInformation_${vehicle.vehRegNo}_ppEndMarker`];
        vehicle.pickupPoints.filter((pp, i) => { markers.push(`g10_routeInformation_${vehicle.vehRegNo}_ppMiddleMarker_${i + 1}`); });
        if (vehicle.endLoc == undefined || vehicle.endLoc == null) markers.pop();
        this.routeInformationMapBox.removeMarker(markers);
        this.routeInformationMapBox.removeLineArrow([`g10_routeInformation_line_${vehicle.vehRegNo}`]);
        setTimeout(() => {
          this.routeInformationMapBox.removeLine([`g10_routeInformation_line_${vehicle.vehRegNo}`]);
        }, 50);
      });
      setTimeout(() => {
        this.vehicleTableData.filter((vehicle) => { this.showTrip(vehicle); });
      }, 500);
    }

  }

  drawSelectedLine() {
    if(this.selectedMap=='google'){
      if(this.globalMarkers.length>0){
        for(let i=0;i<this.globalMarkers.length;i++){
          this.globalMarkers[i].setMap(null);
        }
      }
      this.drawAllRoutesGgl();
    }else{
      this.vehicleTableData.filter((vehicle) => {
  
        let markers = [`g10_routeInformation_${vehicle.vehRegNo}_ppEndMarker`];
        vehicle.pickupPoints.filter((pp, i) => { markers.push(`g10_routeInformation_${vehicle.vehRegNo}_ppMiddleMarker_${i + 1}`); });
        if (vehicle.endLoc == undefined || vehicle.endLoc == null) markers.pop();
        this.routeInformationMapBox.removeMarker(markers);
  
        // this.routeInformationMapBox.removeMarker([`g10_routeInformation_${vehicle.vehRegNo}_ppEndMarker`,`g10_routeInformation_${vehicle.vehRegNo}_ppMiddleMarker`]);
        this.routeInformationMapBox.removeLineArrow([`g10_routeInformation_line_${vehicle.vehRegNo}`]);
        //this.routeInformationMapBox.removeLineAll();
  
        /* let pickupLocations = [];
        vehicle.pickupPoints.map((pp)=>{
          let item = pp;
          return [item.lat, item.lng,{ title: item.title}];
        });
        let vehicleLoc = [vehicle.lat, vehicle.lng,{ title: vehicle.vehRegNo.toUpperCase()}];
        pickupLocations.push(vehicleLoc);
        this.drawLineNoArrow(pickupLocations,vehicle.vehRegNo); */
  
        setTimeout(() => {
          this.routeInformationMapBox.removeLine([`g10_routeInformation_line_${vehicle.vehRegNo}`]);
        }, 50);
      });
      setTimeout(() => {
        this.vehicleTableData.filter((vehicle) => { if (vehicle.checked) this.showTrip(vehicle); })
      }, 500)
    }

  }

  async drawLineNoArrow(locations = [], vehRegNo) {

    let wayPointsLocations: any = await this.routeservice.findWayPoints(locations);

    this.routeInformationMapBox.addLine({
      id: 'g10_routeInformation_line_' + vehRegNo,
      locations: wayPointsLocations.reverse(),
      color: this.getRandomColor(),
      width: 3,
      animation: false,
      bearingFocus: true,
    });
    setTimeout(() => {
      this.routeInformationMapBox.removeLineAll();
    }, 500)
  }

}
